/**
 * @documental
 * @export ValidityGroup
 * @import
 * import { ValidityGroup } from "capitalrx-components-2.0/lib/forms";
 */
import { FC, PropsWithChildren, useMemo } from "react";

import { ValidityGroupContext, ValidityGroupContextValue } from "./ValidityGroupContext";
import { useValidity } from "./useValidity";

/**
 * The `ValidityGroup` component properties.
 */
export interface ValidityGroupProps {
  /**
   * Indicates whether validity of parent groups should be ignored. If not specified defaults to `false`.
   */
  readonly ignoreParent?: boolean;

  /**
   * The validity state.
   */
  readonly invalid?: boolean;

  /**
   * The optional error message.
   */
  readonly error?: string | null;
}

/**
 * A component which informs child input elements whether of their validity.
 */
export const ValidityGroup: FC<PropsWithChildren<ValidityGroupProps>> = (props) => {
  const { ignoreParent = false, invalid = false, error = null, children } = props;

  const [parentInvalid, parentError] = useValidity();

  const contextValue = useMemo((): ValidityGroupContextValue => {
    if (ignoreParent) {
      return { invalid, error };
    } else {
      return {
        invalid: invalid || parentInvalid,
        error: error || parentError,
      };
    }
  }, [invalid, error, parentInvalid, parentError, ignoreParent]);

  return <ValidityGroupContext.Provider value={contextValue}>{children}</ValidityGroupContext.Provider>;
};
